import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { message } from 'antd';

import OnTraccrButton from '../../../common/buttons/OnTraccrButton';

function ConnectToSageIntacct() {
  const divisions = useSelector((state) => state.settings.divisions);
  const [loading, setLoading] = useState(false);

  const divisionIds = useMemo(() => Object.keys(divisions), [divisions]);

  const onClick = useCallback(async () => {
    setLoading(true);
    try {
      // This component is only used for single division companies
      const { data } = await axios.post('/sage/intacct/oauth/authorize', {
        divisions: divisionIds,
        defaultDivisionId: divisionIds[0],
        name: 'Default',
      });
      if (data?.authorizationUrl) {
        window.location.href = data.authorizationUrl;
      } else {
        message.error('Failed to get authorization URL');
      }
    } catch (err) {
      message.error('Failed to initiate Sage Intacct authorization');
    } finally {
      setLoading(false);
    }
  }, [divisionIds]);

  return (
    <div style={{ height: 100, paddingTop: 30 }}>
      <OnTraccrButton
        title="Connect to Sage Intacct"
        type="primary"
        onClick={onClick}
        loading={loading}
      />
    </div>
  );
}

export default ConnectToSageIntacct;
